import React from "react";
import { Card, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import agentConsoleImage from '../Assets/Icons/agentconsle.avif';
import reportPortalImage from '../Assets/Icons/reportportal.avif';
import recordingPortalImage from '../Assets/Icons/recordingportal.avif';
import realTimeDashboardImage from '../Assets/Icons/realtimedashboread.avif';
import "./CSS/HomeComponent.css";

const HomeComponent = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let timeOfDay;
  const date = new Date();
  const hours = date.getHours();
  let greetingColor;

  if (hours < 12) {
    timeOfDay = t("GOOD_MORNING");
    greetingColor = "#D90000";
  } else if (hours >= 12 && hours < 17) {
    timeOfDay = t("GOOD_AFTERNOON");
    greetingColor = "#04733F";
  } else {
    timeOfDay = t("GOOD_EVENING");
    greetingColor = "#04756F";
  }

  return (
    <div className="home-container">
      <h1 className="home-title">{t("HOME_GREETING")}</h1>
      <span className="home-page-greeting" style={{ color: greetingColor }}>
        {timeOfDay}
      </span>
      <p className="home-message">{t("HOME_MESSAGE")}</p>
      <div className="home-cards-container">
        <Card
          className="home-card"
          onClick={() => {
            window.open("https://agentconsole.heedify.io", "_blank");
          }}
        >
          <div className="home-card-body">
            <div className="home-card-image-container">
              <img src={agentConsoleImage} alt="Agent Console" className="home-card-image " />
            </div>
            <Text className="home-card-name">{t("AGENT_CONSOLE")}</Text>
          </div>
        </Card>

      </div>
    </div>
  );
};

export default HomeComponent;